import { render, staticRenderFns } from "./table.vue?vue&type=template&id=b89c61de&scoped=true&"
import script from "./table.vue?vue&type=script&lang=ts&"
export * from "./table.vue?vue&type=script&lang=ts&"
import style0 from "./table.vue?vue&type=style&index=0&id=b89c61de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89c61de",
  null
  
)

export default component.exports